import './AdminTools.css';

import { useState } from 'react';
import { Login } from './components/Login';
import { CharacterSearch } from './components/CharacterSearch';
import { useEffect } from 'react';

export function AdminTools() {
  useEffect(() => {
    window.location.replace(`${window.location.protocol}//${window.location.hostname}:6512/admin/`);
  }, []);
  const [state, setState] = useState(0);

  if (state === 0) {
    return <Login onLogin={() => setState(1)} />;
  }

  return (
    <div style={{ padding: 5 }}>
      <CharacterSearch />
    </div>
  );
}
